/* My Cottage Garden – Saatgut-Geschenkset (Custom Element <mcg-seed-builder>) */
(function () {
  'use strict';

  var MCG = window.MCG;
  if (!MCG) {
    console.error('MCG: mcg-set-core.js wurde nicht geladen (Assets prüfen).');
    return;
  }
  if (customElements.get('mcg-seed-builder')) return;

  var SIZES = [5, 10, 20, 24];
  var esc = MCG.esc;

  /* "Name | #hex #hex | stichwort, stichwort" pro Zeile */
  function parseGroups(text) {
    return String(text || '').split(/\r?\n/).map(function (line, i) {
      var parts = line.split('|');
      if (parts.length < 3) return null;
      var name = parts[0].trim();
      var dots = parts[1].trim().split(/\s+/).filter(function (d) { return /^#[0-9a-f]{3,8}$/i.test(d); });
      var words = parts[2].split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
      if (!name || !words.length) return null;
      return { id: 'g' + i, name: name, dots: dots, words: words };
    }).filter(Boolean);
  }

  /* "Anzeigename | Wert" oder nur "Wert" pro Zeile */
  function parseProps(text) {
    return String(text || '').split(/\r?\n/).map(function (line, i) {
      var parts = line.split('|');
      var label = parts[0].trim();
      var value = (parts[1] || parts[0]).trim().toLowerCase();
      if (!label || !value) return null;
      return { id: 'p' + i, label: label, value: value };
    }).filter(Boolean);
  }

  class McgSeedBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      var node = this.querySelector('script[data-config]');
      var cfg;
      try {
        cfg = JSON.parse(node.textContent);
      } catch (e) {
        console.error('MCG: Konfiguration konnte nicht gelesen werden.', e);
        return;
      }
      this.ready = true;
      this.init(cfg);
    }

    /* ---------- Aufbau ---------- */

    init(cfg) {
      var self = this;
      this.cfg = cfg;
      this.cur = cfg.currency;
      this.sets = cfg.sets || {};

      var excluded = (cfg.excludedVendors || [])
        .map(function (v) { return String(v).trim().toLowerCase(); })
        .filter(Boolean);

      this.groups = parseGroups(cfg.colorGroups);
      this.propDefs = parseProps(cfg.propFilters);

      this.seeds = (cfg.seeds || []).filter(function (s) {
        return s.available && excluded.indexOf(String(s.vendor || '').trim().toLowerCase()) === -1;
      });
      this.seedById = {};
      this.seeds.forEach(function (s) {
        self.seedById[s.id] = s;
        var hay = (s.colors || []).join(' ').toLowerCase();
        s.groupIds = self.groups.filter(function (g) {
          return g.words.some(function (w) { return hay.indexOf(w) !== -1; });
        }).map(function (g) { return g.id; });
        var own = (s.props || []).map(function (v) { return String(v).trim().toLowerCase(); });
        s.propIds = self.propDefs.filter(function (d) {
          return own.indexOf(d.value) !== -1;
        }).map(function (d) { return d.id; });
      });

      this.extras = (cfg.extras || []).filter(function (e) { return e.variants && e.variants.length; });
      this.extraById = {};
      this.extraState = {};
      this.extras.forEach(function (e) {
        self.extraById[e.id] = e;
        self.extraState[e.id] = { on: false, variantId: e.variants[0].id };
      });

      this.size = 5;
      for (var i = 0; i < SIZES.length; i++) {
        var s = this.sets[SIZES[i]];
        if (s && s.available) { this.size = SIZES[i]; break; }
      }
      this.selected = [];
      this.editing = false;
      this.busy = false;
      this.activeGroup = '';
      this.activeProps = [];

      var q = function (sel) { return self.querySelector(sel); };
      this.elSizes = q('[data-sizes]');
      this.elDone = q('[data-done]');
      this.elDoneText = q('[data-done-text]');
      this.elEdit = q('[data-edit]');
      this.elPicker = q('[data-picker]');
      this.elSearch = q('[data-search]');
      this.elFilters = q('[data-filters]');
      this.elProps = q('[data-props]');
      this.elSeeds = q('[data-seeds]');
      this.elExtrasHeading = q('[data-extras-heading]');
      this.elHint = q('[data-extra-hint]');
      this.elExtras = q('[data-extras]');
      this.elStatus = q('[data-status]');
      this.elCount = q('[data-count]');
      this.elSlots = q('[data-slots]');
      this.elTotal = q('[data-total]');
      this.elAdd = q('[data-add]');
      this.elPickedWrap = q('[data-picked-wrap]');
      this.elPickedSummary = q('[data-picked-summary]');
      this.elPickedList = q('[data-picked-list]');

      this.tip = document.createElement('div');
      this.tip.className = 'mcg-tip';
      this.tip.hidden = true;
      this.appendChild(this.tip);

      this.renderSizes();
      this.renderFilters();
      this.renderProps();
      this.renderSeeds();
      this.renderExtras();
      this.bind();
      this.setupAdvisor();
      this.update();
    }

    renderSizes() {
      var self = this;
      this.elSizes.innerHTML = SIZES.map(function (n) {
        var set = self.sets[n];
        var ok = set && set.available;
        return '<button type="button" class="mcg-size" data-size="' + n + '" aria-pressed="false"' + (ok ? '' : ' disabled') + '>' +
          '<span class="mcg-size__name">' + n + ' Sorten</span>' +
          '<span class="mcg-size__price">' + (ok ? MCG.money(set.price, self.cur) : 'Nicht verfügbar') + '</span>' +
          '</button>';
      }).join('');
    }

    renderFilters() {
      var self = this;
      var used = this.groups.filter(function (g) {
        return self.seeds.some(function (s) { return s.groupIds.indexOf(g.id) !== -1; });
      });
      if (!used.length) {
        if (this.cfg.designMode && this.groups.length) {
          var withColor = this.seeds.filter(function (s) { return s.colors && s.colors.length; }).length;
          this.elFilters.innerHTML = '<p class="mcg-empty">Hinweis nur im Theme-Editor: Farbfilter ist an, aber keine Sorte passt zu den Farbgruppen. ' +
            withColor + ' von ' + this.seeds.length + ' Sorten haben Farbdaten' +
            (withColor ? ' (z. B. „' + esc(this.seeds.filter(function (s) { return s.colors && s.colors.length; })[0].colors[0]) + '“). Prüfe die Stichwörter in „Farbgruppen“.' : '. Prüfe Kollektion und Metafeld-Name.') + '</p>';
          this.elFilters.hidden = false;
        } else {
          this.elFilters.hidden = true;
        }
        return;
      }
      var chips = ['<button type="button" class="mcg-chip" data-group="" aria-pressed="true">Alle Farben</button>'];
      used.forEach(function (g) {
        var dots = g.dots.map(function (d) {
          return '<span class="mcg-chip__dot" style="background:' + esc(d) + '"></span>';
        }).join('');
        chips.push('<button type="button" class="mcg-chip" data-group="' + esc(g.id) + '" aria-pressed="false">' + dots + esc(g.name) + '</button>');
      });
      this.elFilters.innerHTML = chips.join('');
      this.elFilters.hidden = false;
    }

    renderProps() {
      var self = this;
      if (!this.elProps) return;
      var used = this.propDefs.filter(function (d) {
        return self.seeds.some(function (s) { return s.propIds.indexOf(d.id) !== -1; });
      });
      if (!used.length) {
        if (this.cfg.designMode && this.propDefs.length) {
          var withProps = this.seeds.filter(function (s) { return s.props && s.props.length; }).length;
          this.elProps.innerHTML = '<p class="mcg-empty">Hinweis nur im Theme-Editor: Eigenschaften-Filter ist an, aber keine Sorte passt. ' +
            withProps + ' von ' + this.seeds.length + ' Sorten haben Eigenschaften. Der Text in „Angezeigte Eigenschaften“ muss genau dem Wert im Metafeld entsprechen.</p>';
          this.elProps.hidden = false;
        } else {
          this.elProps.hidden = true;
        }
        return;
      }
      this.elProps.innerHTML = used.map(function (d) {
        return '<button type="button" class="mcg-chip" data-prop="' + esc(d.id) + '" aria-pressed="false">' + esc(d.label) + '</button>';
      }).join('');
      this.elProps.hidden = false;
    }

    renderSeeds() {
      this.elSeeds.innerHTML = this.seeds.map(function (s) {
        return '<button type="button" class="mcg-seed" data-id="' + esc(s.id) + '" data-title="' + esc(String(s.title).toLowerCase()) + '" data-groups="' + esc(s.groupIds.join(' ')) + '" data-props="' + esc(s.propIds.join(' ')) + '" aria-pressed="false">' +
          '<span class="mcg-seed__img">' + (s.image ? '<img src="' + esc(s.image) + '" alt="" loading="lazy" width="440" height="440">' : '') + '</span>' +
          '<span class="mcg-seed__title">' + esc(s.title) + '</span>' +
          '<span class="mcg-seed__check">' + MCG.icons.check + '</span>' +
          '</button>';
      }).join('');

      this.elEmpty = document.createElement('p');
      this.elEmpty.className = 'mcg-empty';
      this.elEmpty.hidden = true;
      this.elEmpty.textContent = this.seeds.length ? 'Keine passende Sorte gefunden.' : 'Gerade sind keine Sorten verfügbar.';
      this.elSeeds.insertAdjacentElement('afterend', this.elEmpty);
      if (!this.seeds.length) this.elEmpty.hidden = false;
    }

    renderExtras() {
      if (!this.extras.length) {
        this.elExtrasHeading.hidden = true;
        this.elHint.hidden = true;
        if (this.cfg.designMode) {
          this.elExtras.innerHTML = '<p class="mcg-empty">Hinweis nur im Theme-Editor: Es wurden keine verfügbaren Extra-Produkte gefunden. Wähle sie links unter „Extra-Produkte“ aus und prüfe, ob sie aktiv und im Vertriebskanal „Online Shop“ veröffentlicht sind.</p>';
        }
        return;
      }
      this.elExtras.innerHTML = this.extras.map(function (e) {
        var select = '';
        if (e.variants.length > 1) {
          select = '<select data-extra-variant aria-label="Variante für ' + esc(e.title) + '">' +
            e.variants.map(function (v) {
              return '<option value="' + esc(v.id) + '">' + esc(v.title || '') + '</option>';
            }).join('') + '</select>';
        }
        return '<article class="mcg-extra" data-extra="' + esc(e.id) + '">' +
          '<div class="mcg-extra__img">' + (e.image ? '<img src="' + esc(e.image) + '" alt="" loading="lazy" width="200" height="200">' : '') + '</div>' +
          '<div class="mcg-extra__body"><h3 class="mcg-extra__title">' + esc(e.title) + '</h3>' +
          '<p class="mcg-extra__price" data-extra-price></p>' + select + '</div>' +
          '<button type="button" class="mcg-button mcg-button--outline" data-extra-toggle>Hinzufügen</button>' +
          '</article>';
      }).join('');
    }

    bind() {
      var self = this;

      this.addEventListener('click', function (ev) {
        var btn = ev.target.closest('button');
        if (!btn || !self.contains(btn)) return;

        if (btn.hasAttribute('data-size')) {
          self.setSize(Number(btn.getAttribute('data-size')));
        } else if (btn.hasAttribute('data-prop')) {
          var pid = btn.getAttribute('data-prop');
          var at = self.activeProps.indexOf(pid);
          if (at === -1) self.activeProps.push(pid); else self.activeProps.splice(at, 1);
          btn.setAttribute('aria-pressed', String(at === -1));
          self.applyFilters();
        } else if (btn.hasAttribute('data-group')) {
          self.activeGroup = btn.getAttribute('data-group');
          self.elFilters.querySelectorAll('.mcg-chip').forEach(function (c) {
            c.setAttribute('aria-pressed', String(c === btn));
          });
          self.applyFilters();
        } else if (btn.classList.contains('mcg-seed')) {
          self.toggleSeed(btn.getAttribute('data-id'));
        } else if (btn.hasAttribute('data-remove')) {
          self.hideTip();
          self.removeSeed(btn.getAttribute('data-remove'));
        } else if (btn.hasAttribute('data-pick')) {
          var id = btn.getAttribute('data-pick');
          if (self.selected.indexOf(id) === -1) self.toggleSeed(id);
        } else if (btn.hasAttribute('data-extra-toggle')) {
          self.toggleExtra(btn.closest('[data-extra]').getAttribute('data-extra'));
        } else if (btn.hasAttribute('data-edit')) {
          self.editing = !self.editing;
          self.update();
        } else if (btn.hasAttribute('data-add')) {
          self.add();
        }
      });

      this.addEventListener('change', function (ev) {
        var el = ev.target;
        if (el && el.matches && el.matches('[data-extra-variant]')) {
          var id = el.closest('[data-extra]').getAttribute('data-extra');
          self.extraState[id].variantId = el.value;
          self.update();
        }
      });

      if (this.elSearch) {
        this.elSearch.addEventListener('input', function () { self.applyFilters(); });
      }

      /* Sortenname beim Darüberfahren über die kleinen Bilder unten */
      this.elSlots.addEventListener('mouseover', function (ev) { self.showTip(ev.target); });
      this.elSlots.addEventListener('focusin', function (ev) { self.showTip(ev.target); });
      this.elSlots.addEventListener('mouseout', function () { self.hideTip(); });
      this.elSlots.addEventListener('focusout', function () { self.hideTip(); });
    }

    showTip(target) {
      var slot = target.closest ? target.closest('.mcg-slot--filled') : null;
      if (!slot) { this.hideTip(); return; }
      var rect = slot.getBoundingClientRect();
      this.tip.textContent = slot.getAttribute('data-title') || '';
      this.tip.style.left = Math.max(80, Math.min(window.innerWidth - 80, rect.left + rect.width / 2)) + 'px';
      this.tip.style.top = (rect.top - 8) + 'px';
      this.tip.hidden = false;
    }

    hideTip() {
      if (this.tip) this.tip.hidden = true;
    }

    applyFilters() {
      var term = this.elSearch ? this.elSearch.value.trim().toLowerCase() : '';
      var group = this.activeGroup;
      var wanted = this.activeProps;
      var shown = 0;
      this.elSeeds.querySelectorAll('.mcg-seed').forEach(function (btn) {
        var okTerm = !term || btn.getAttribute('data-title').indexOf(term) !== -1;
        var okGroup = !group || (' ' + btn.getAttribute('data-groups') + ' ').indexOf(' ' + group + ' ') !== -1;
        var own = ' ' + btn.getAttribute('data-props') + ' ';
        var okProps = wanted.every(function (id) { return own.indexOf(' ' + id + ' ') !== -1; });
        var hit = okTerm && okGroup && okProps;
        btn.hidden = !hit;
        if (hit) shown++;
      });
      this.elEmpty.hidden = shown > 0 || !this.seeds.length;
    }

    /* ---------- Aktionen ---------- */

    say(text) {
      if (this.elStatus) this.elStatus.textContent = text || '';
    }

    setSize(n) {
      var set = this.sets[n];
      if (!set || !set.available) return;
      this.size = n;
      if (this.selected.length > n) this.selected = this.selected.slice(0, n);
      this.say('');
      this.update();
    }

    toggleSeed(id) {
      var idx = this.selected.indexOf(id);
      if (idx !== -1) {
        this.selected.splice(idx, 1);
        this.say('');
        this.update();
        return;
      }
      if (!this.seedById[id]) return;
      if (this.selected.length >= this.size) {
        this.say('Dein Set ist voll. Entferne zuerst eine Sorte, um eine andere zu wählen.');
        return;
      }
      this.selected.push(id);
      this.say('');
      this.update();
      if (this.selected.length === this.size) {
        var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.elDone.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' });
      }
    }

    removeSeed(id) {
      var idx = this.selected.indexOf(id);
      if (idx === -1) return;
      this.selected.splice(idx, 1);
      this.say('');
      this.update();
    }

    toggleExtra(id) {
      if (this.selected.length !== this.size) return;
      var st = this.extraState[id];
      if (!st) return;
      st.on = !st.on;
      this.update();
    }

    variantOf(extra) {
      var wanted = this.extraState[extra.id].variantId;
      for (var i = 0; i < extra.variants.length; i++) {
        if (extra.variants[i].id === wanted) return extra.variants[i];
      }
      return extra.variants[0];
    }

    total() {
      var self = this;
      var set = this.sets[this.size];
      var sum = set ? Number(set.price) : 0;
      this.extras.forEach(function (e) {
        if (self.extraState[e.id].on) sum += Number(self.variantOf(e).price);
      });
      return sum;
    }

    add() {
      var self = this;
      var set = this.sets[this.size];
      if (!set || this.busy || this.selected.length !== this.size) return;

      var props = {};
      this.selected.forEach(function (id, i) {
        props['Sorte ' + (i + 1)] = self.seedById[id].title;
      });

      var items = [{ id: Number(set.variantId), quantity: 1, properties: props }];
      this.extras.forEach(function (e) {
        var st = self.extraState[e.id];
        if (st.on) items.push({ id: Number(st.variantId), quantity: 1 });
      });

      this.busy = true;
      this.say('Dein Set wird in den Warenkorb gelegt …');
      this.update();

      MCG.addToCart(this.cfg.root, items).then(function () {
        self.say('Im Warenkorb. Du wirst weitergeleitet …');
        window.location.href = (self.cfg.root || '/') + 'cart';
      }).catch(function (err) {
        self.busy = false;
        self.say(err.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
        self.update();
      });
    }

    /* ---------- Anzeige aktualisieren ---------- */

    update() {
      var self = this;
      var set = this.sets[this.size];
      var full = this.selected.length === this.size;
      if (!full) this.editing = false;

      this.elSizes.querySelectorAll('.mcg-size').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(Number(btn.getAttribute('data-size')) === self.size));
      });

      this.elSeeds.querySelectorAll('.mcg-seed').forEach(function (btn) {
        var on = self.selected.indexOf(btn.getAttribute('data-id')) !== -1;
        btn.setAttribute('aria-pressed', String(on));
        btn.disabled = full && !on;
      });

      this.elDone.hidden = !full;
      this.elDoneText.innerHTML = MCG.icons.check + ' Deine ' + this.size + ' Sorten sind ausgewählt.';
      this.elEdit.textContent = this.editing ? 'Auswahl schließen' : 'Sorten ändern';
      this.elPicker.hidden = full && !this.editing;

      this.updateExtras(full);
      this.updateBar(set, full);
    }

    updateExtras(full) {
      var self = this;
      if (!this.extras.length) return;
      this.elHint.hidden = full;
      this.elExtras.classList.toggle('mcg-extras--locked', !full);

      this.elExtras.querySelectorAll('[data-extra]').forEach(function (card) {
        var extra = self.extraById[card.getAttribute('data-extra')];
        var st = self.extraState[extra.id];
        var v = self.variantOf(extra);
        var price = '';
        if (v.compareAtPrice && Number(v.compareAtPrice) > Number(v.price)) {
          price += '<s>' + MCG.money(v.compareAtPrice, self.cur) + '</s>';
        }
        price += MCG.money(v.price, self.cur);
        card.querySelector('[data-extra-price]').innerHTML = price;
        card.classList.toggle('mcg-extra--on', st.on);

        var toggle = card.querySelector('[data-extra-toggle]');
        toggle.textContent = st.on ? 'Entfernen' : 'Hinzufügen';
        toggle.setAttribute('aria-pressed', String(st.on));
        toggle.disabled = !full;
      });
    }

    updateBar(set, full) {
      var self = this;
      var n = this.selected.length;

      this.elCount.textContent = n + ' / ' + this.size + ' Sorten';
      this.elTotal.textContent = MCG.money(this.total(), this.cur);
      this.elSlots.setAttribute('data-size', String(this.size));

      var slots = '';
      for (var i = 0; i < this.size; i++) {
        var seed = this.seedById[this.selected[i]];
        if (!seed) {
          slots += '<span class="mcg-slot" aria-hidden="true"></span>';
        } else {
          slots += '<span class="mcg-slot mcg-slot--filled" data-title="' + esc(seed.title) + '">' +
            (seed.image ? '<img src="' + esc(seed.image) + '" alt="' + esc(seed.title) + '" width="168" height="168">' : '') +
            '<button type="button" class="mcg-slot__remove" data-remove="' + esc(seed.id) + '" aria-label="' + esc(seed.title) + ' entfernen">' + MCG.icons.close + '</button>' +
            '</span>';
        }
      }
      this.elSlots.innerHTML = slots;

      this.elAdd.disabled = !full || this.busy || !set || !set.available;
      this.elAdd.innerHTML = full ? MCG.icons.gift + ' In den Warenkorb' : 'Set vervollständigen';

      this.elPickedWrap.hidden = n === 0;
      this.elPickedSummary.textContent = 'Deine Auswahl (' + n + ' von ' + this.size + ')';
      this.elPickedList.innerHTML = this.selected.map(function (id) {
        var s = self.seedById[id];
        return '<li><span>' + esc(s.title) + '</span> <button type="button" class="mcg-link" data-remove="' + esc(id) + '">entfernen</button></li>';
      }).join('');
    }

    /* ---------- KI-Beratung (optional, braucht App-Proxy) ---------- */

    setupAdvisor() {
      var self = this;
      var form = this.querySelector('[data-advisor]');
      if (!form) return;
      var statusEl = form.querySelector('[data-advisor-status]');
      var results = form.querySelector('[data-results]');

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var data = {};
        new FormData(form).forEach(function (value, key) { data[key] = value; });
        data.size = self.size;
        data.seeds = self.seeds.map(function (s) {
          return { handle: s.handle, title: s.title, vendor: s.vendor };
        });

        statusEl.textContent = 'Einen Moment, wir suchen passende Sorten …';
        results.innerHTML = '';

        fetch(self.cfg.proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(data)
        }).then(function (response) {
          if (!response.ok) throw new Error('proxy');
          return response.json();
        }).then(function (json) {
          var list = json.recommendations || json.empfehlungen || [];
          var html = list.map(function (item) {
            var seed = null;
            for (var i = 0; i < self.seeds.length; i++) {
              if (self.seeds[i].handle === item.handle || self.seeds[i].title === item.title) { seed = self.seeds[i]; break; }
            }
            if (!seed) return '';
            var reason = item.reason || item.grund || '';
            return '<div class="mcg-result"><div><strong>' + esc(seed.title) + '</strong>' +
              (reason ? '<p>' + esc(reason) + '</p>' : '') + '</div>' +
              '<button type="button" class="mcg-button mcg-button--outline" data-pick="' + esc(seed.id) + '">Auswählen</button></div>';
          }).join('');
          results.innerHTML = html;
          statusEl.textContent = html ? 'Das passt zu Deinen Angaben:' : 'Dazu haben wir leider keine Empfehlung gefunden.';
        }).catch(function () {
          statusEl.textContent = 'Die Beratung ist gerade nicht erreichbar. Du kannst Deine Sorten unten selbst auswählen.';
        });
      });

      form.addEventListener('reset', function () {
        results.innerHTML = '';
        statusEl.textContent = '';
        self.selected = [];
        self.say('');
        self.update();
      });
    }
  }

  customElements.define('mcg-seed-builder', McgSeedBuilder);
})();